import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/customer-dashboard/components/CustomerDashboardInteractive.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/common/AppLayout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/common/RouteGuard.tsx");
